/**
 * Centralized logging utility
 * In production, logs are filtered and errors are sent to monitoring service
 */

type LogLevel = 'log' | 'warn' | 'error' | 'debug';

class Logger {
  private isDevelopment = process.env.NODE_ENV === 'development';

  private shouldLog(level: LogLevel): boolean {
    if (level === 'error') return true; // Always log errors
    return this.isDevelopment;
  }

  log(...args: unknown[]): void {
    if (this.shouldLog('log')) {
      console.log(...args);
    }
  }

  warn(...args: unknown[]): void {
    if (this.shouldLog('warn')) {
      console.warn(...args);
    }
  }

  error(...args: unknown[]): void {
    console.error(...args);
    // TODO: Send to error tracking service (e.g., Sentry) in production
    if (!this.isDevelopment) {
      // Error tracking service integration would go here
    }
  }

  debug(...args: unknown[]): void {
    if (this.shouldLog('debug')) {
      console.debug(...args);
    }
  }
}

export const logger = new Logger();
export default logger;
